import axios from "axios";
import tool from "@/utils/tool";
import { Message } from "element-ui";
let count = 0;
const instance = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? "/robot-dev-boe/robot-dev-boe/"
      : "/robot-dev-boe/",
  timeout: 30 * 1000,
  headers: {
    validToken: "1234567890",
  },
});

instance.interceptors.request.use(
  (config) => {
    if (window.sessionStorage.getItem("openToken")) {
      config.headers["openToken"] = sessionStorage.getItem("openToken");
    } else {
      config.headers["openToken"] = tool.getCookie("boeToken");
    }
    if (config.headers.validToken) {
      return config;
    } else {
      config.data = JSON.stringify(config.data); //数据转化
      // config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      return config;
    }
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response) {
      if (response.data.errorCode === 0) {
        return response.data;
      }
      if (response.data.code !== 0 && count === 0) {
        Message({
          type: "warning",
          message: response.data.message ? response.data.message : "系统错误",
        });
        count++;
      }
      return response.data;
    } else {
      return Promise.reject({ message: "系统繁忙,请稍后再试" });
    }
  },
  (error) => {
    console.log(error);
  }
);

export default instance;
